import { ColorEnum } from '@/constants/color'
import { ShiftCloseoutHistoryRowContentProps } from '@/features/shiftCloseouts/components/CreateShiftCloseoutPrompt/parts/ShiftCloseoutHistory/parts/ShiftCloseoutHistoryRow/types'
import { formatShiftCloseoutHistoryDate } from '@/features/shiftCloseouts/utils/formatShiftCloseoutHistoryDate'
import IconButton from '@/features/ui/buttons/components/IconButton'
import PrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import Typography from '@/features/ui/typography'
import { formatPrice } from '@/utils/priceHelper'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const ExtendedShiftCloseoutHistoryRow: FC<ShiftCloseoutHistoryRowContentProps> = ({
    item,
    onReprint,
    printing,
}) => {
    const { t } = useTranslation()
    const { styles } = useStyles(stylesheet)
    const { date, weekday } = formatShiftCloseoutHistoryDate(item.closedAt)

    return (
        <View style={styles.container}>
            <View style={styles.date}>
                <Typography.Description font="bold" size="large">
                    {date}
                </Typography.Description>
                <Typography.Description font="medium" style={styles.weekday}>
                    {weekday}
                </Typography.Description>
            </View>
            <View style={styles.cell}>
                <Typography.Description font="bold" size="large" style={styles.total}>
                    {formatPrice(item.totalAmount.amount, item.totalAmount.currency)}
                </Typography.Description>
            </View>
            <View style={styles.cell}>
                {item.profileName && (
                    <Typography.Description font="medium" size="large">
                        {item.profileName}
                    </Typography.Description>
                )}
            </View>
            <IconButton
                accessibilityLabel={t('shiftCloseouts.history.reprint')}
                accessibilityRole="button"
                disabled={printing}
                Icon={PrinterIcon}
                onPress={onReprint}
                testID={`reprint-shift-closeout-${item.uuid}`}
                type="outline"
            />
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 16,
        padding: 16,
        borderColor: ColorEnum.GRAY_200,
        borderRadius: 8,
        borderWidth: 1,
        backgroundColor: ColorEnum.WHITE,
    },
    date: {
        flex: 1,
        minWidth: 0,
        gap: 4,
    },
    weekday: {
        color: ColorEnum.GRAY_600,
    },
    cell: {
        flex: 1,
        minWidth: 0,
        justifyContent: 'center',
    },
    total: {
        color: ColorEnum.Emerald600,
    },
})

export default ExtendedShiftCloseoutHistoryRow
